import React from 'react';

interface HealthCircleProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  innerRadius?: number;
  showText?: boolean;
  fontSize?: string;
  className?: string;
}

export const HealthCircle: React.FC<HealthCircleProps> = ({
  score,
  size = 48,
  strokeWidth = 6,
  innerRadius = 16,
  showText = false,
  fontSize = '12px',
  className = ''
}) => {
  const radius = innerRadius + strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  
  const scoreColor = score >= 75 ? '#22c55e' : score >= 50 ? '#eab308' : '#ef4444';

  return (
    <div 
      className={`relative inline-flex items-center justify-center ${className}`} 
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="transform -rotate-90"
      >
        {/* Background Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          className="text-gray-100 dark:text-gray-800"
        />
        {/* Progress Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke={scoreColor}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-500 ease-out"
        />
      </svg>
      {showText && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-black text-gray-900 dark:text-white leading-none" style={{ fontSize }}>
            {score}
          </span>
        </div>
      )}
    </div>
  );
};
